import { actionCreatorFactory } from 'typescript-fsa'
import { Auth } from '../../types'

const actionCreator = actionCreatorFactory()

export const saveAuth = actionCreator<Partial<Auth>>('saveAuth')
export const removeAuth = actionCreator('removeAuth')
export const authStart = actionCreator('authStart')
export const authEnd = actionCreator('authEnd')
